/* FJC 2026-10-14: "Request a Ring Sizer" drawer (snippets/fjc-ring-sizer-drawer.liquid).

   - window.fjcRingSizer.open({ productTitle, url }, trigger) opens the drawer; the Ring Size
     Guide's "REQUEST A COMPLIMENTARY RING SIZER" button (snippets/fjc-ring-size-picker.liquid)
     calls it. close() closes it and dispatches "fjc-ring-sizer:closed" on document with
     detail { sent: true|false }, so the guide can come back (not sent) or close too (sent).
   - Any link whose address ends in #request-ring-sizer opens the drawer in place of
     navigating (2026-10-23: the footer's "Request a Ring Sizer" item in the Services menu,
     Online Store > Navigation; the drawer is on every page for it). The email then reads
     "Product: Footer link" (or "Site link" elsewhere) with the page the customer was on.
     A page that loads with that hash (the link clicked before this script ran) opens the
     drawer too and drops the hash from the address.
   - Submission: the Shopify contact form in the drawer, posted by fetch (no reload), then the
     success view. Shopify's spam-protection captcha is honoured the same way as the Notify Me
     drawer (assets/fjc-notify-me.js): the drawer installs its own form.submit() before the
     captcha provider binds the form, so the provider hands the token-carrying form here.
   - Address auto-fill: Google Places, Autocomplete Data API of the Places library (the
     Places API (New); the legacy Autocomplete widget is closed to new Google Cloud projects
     since March 2025). The Maps JavaScript API loads only when the drawer first opens and
     only when the theme setting holds a key (data-fjc-google-key). Suggestions are limited
     to the United Kingdom and Ireland (the free sizer ships there only), rendered in the
     theme's own list under the Address line, and a chosen place fills Address, Apartment,
     City, State / Province / Region, Postcode and Country. Without a key, or if Google
     fails, the form is a plain typed form. */
(function () {
  'use strict';

  var api = window.fjcRingSizer = window.fjcRingSizer || {};
  var drawer = document.getElementById('fjc-ring-sizer-drawer');
  if (!drawer) return;

  var form = document.getElementById('fjc-ring-sizer-form');
  var panel = drawer.querySelector('.cp-email-drawer__panel');
  var lastTrigger = null;
  var sent = false;
  var inFlight = false;

  function view(name) {
    return drawer.querySelector('[data-fjc-sizer-view="' + name + '"]');
  }
  function showView(name) {
    var formView = view('form');
    var successView = view('success');
    if (formView) formView.hidden = name !== 'form';
    if (successView) successView.hidden = name !== 'success';
  }
  function setError(text) {
    var err = drawer.querySelector('[data-fjc-sizer-error]');
    if (!err) return;
    err.textContent = text || '';
    err.hidden = !text;
  }
  function hiddenField(key) {
    return drawer.querySelector('[data-fjc-sizer-field="' + key + '"]');
  }
  function setHidden(key, value) {
    var input = hiddenField(key);
    if (input) input.value = value || '';
  }
  function submitButton() {
    return drawer.querySelector('[data-fjc-sizer-submit]');
  }
  function isOpen() {
    return drawer.classList.contains('cp-email-drawer--open');
  }

  /* ---------------- Open / close ---------------- */

  function openDrawer(details, trigger) {
    details = details || {};
    lastTrigger = trigger || null;
    sent = false;
    setHidden('product', details.productTitle);
    setHidden('url', details.url || window.location.href);
    setError('');
    showView('form');
    var submit = submitButton();
    if (submit) submit.disabled = false;
    drawer.classList.add('cp-email-drawer--open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('fjc-drawer-open');
    places.boot();
    setTimeout(function () {
      if (!isOpen() || !form) return;
      // first empty field a customer has to fill (the Title select already holds a value)
      var target = null;
      var inputs = form.querySelectorAll('input.fjc-sizer-field__input');
      for (var i = 0; i < inputs.length; i++) {
        if (!inputs[i].value) { target = inputs[i]; break; }
      }
      (target || panel).focus();
    }, 380);
  }

  function closeDrawer() {
    if (!isOpen()) return;
    places.hide();
    drawer.classList.remove('cp-email-drawer--open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('fjc-drawer-open');
    var wasSent = sent;
    if (wasSent && form) {
      // a fresh form for the next request
      form.reset();
      showView('form');
      sent = false;
    }
    if (lastTrigger && typeof lastTrigger.focus === 'function' && !wasSent) lastTrigger.focus();
    lastTrigger = null;
    try {
      document.dispatchEvent(new CustomEvent('fjc-ring-sizer:closed', { detail: { sent: wasSent } }));
    } catch (e) { /* very old engines without CustomEvent: nothing listens there */ }
  }

  api.open = openDrawer;
  api.close = closeDrawer;
  api.isOpen = isOpen;

  /* ---------------- Submission ---------------- */

  // Default backend: the Shopify contact form rendered in the drawer ({% form 'contact' %}),
  // posted by fetch. Shopify answers with a redirect back to the page (contact_posted=true)
  // on success, or sends the request to its spam challenge page, which cannot be completed
  // from a fetch. Replace this one function to send requests elsewhere.
  api.submit = api.submit || function (formEl) {
    var body = new FormData(formEl);
    return fetch(formEl.getAttribute('action') || '/contact', {
      method: 'POST',
      body: body,
      credentials: 'same-origin',
      headers: { 'Accept': 'text/html' }
    }).then(function (response) {
      if (!response.ok) throw new Error('HTTP ' + response.status);
      if (/\/challenge/.test(response.url || '')) throw new Error('challenge');
      return true;
    });
  };

  function runSubmit(formEl) {
    if (inFlight) return;
    inFlight = true;
    var submit = submitButton();
    if (submit) submit.disabled = true;
    setError('');
    places.hide();
    // the sender name Shopify prints in the email header
    var first = (formEl.querySelector('#FjcSizerFirstName') || {}).value || '';
    var last = (formEl.querySelector('#FjcSizerLastName') || {}).value || '';
    setHidden('name', (first + ' ' + last).trim());
    Promise.resolve()
      .then(function () { return api.submit(formEl); })
      .then(function () {
        inFlight = false;
        sent = true;
        showView('success');
        if (panel) panel.scrollTop = 0;
        var heading = drawer.querySelector('.fjc-sizer-drawer__success-heading');
        if (heading) heading.focus();
      })
      .catch(function () {
        inFlight = false;
        if (submit) submit.disabled = false;
        setError('Sorry, we could not send your request just now. Please try again in a moment, or contact us and we will post a ring sizer to you.');
      });
  }

  // Shopify's spam protection binds every /contact form the first time it is focused and,
  // on submit, fetches a token and calls form.submit(): a native submission that would
  // reload the page. An own submit() installed before that point makes the provider hand
  // the token-carrying form to this script instead (see assets/fjc-notify-me.js).
  function captchaBound(formEl) {
    return formEl.dataset.hcaptchaBound === 'true' || formEl.dataset.recaptchaBound === 'true';
  }
  function hookCaptchaSubmit() {
    if (!form || form._fjcSubmitHooked) return;
    form._fjcSubmitHooked = true;
    try {
      form.submit = function () { runSubmit(form); };
    } catch (e) { /* read-only in some old engines; the fetch path below still works */ }
  }

  function handleSubmit(e) {
    var formEl = e.target;
    if (!formEl || formEl.id !== 'fjc-ring-sizer-form') return;
    e.preventDefault();
    if (typeof formEl.reportValidity === 'function' && !formEl.reportValidity()) return;
    if (captchaBound(formEl)) {
      // the provider's own submit listener ran first and will call form.submit() (runSubmit)
      // once it has a token; posting here too would send the request twice
      var submit = submitButton();
      if (submit) {
        submit.disabled = true;
        setTimeout(function () { if (!inFlight) submit.disabled = false; }, 6000);
      }
      return;
    }
    runSubmit(formEl);
  }

  /* ---------------- Google Places address suggestions ---------------- */

  var places = (function () {
    var key = (drawer.getAttribute('data-fjc-google-key') || '').trim();
    var input = drawer.querySelector('[data-fjc-sizer-address]');
    var list = document.getElementById('FjcSizerAddressList');
    var noop = { boot: function () {}, hide: function () {}, isListOpen: function () { return false; } };
    if (!key || !input || !list) return noop;

    var REGION_CODES = ['gb', 'ie']; // the free ring sizer ships to the UK and Ireland only
    var ADDRESS_TYPES = ['street_address', 'premise', 'subpremise', 'route', 'postal_code'];
    var lib = null;
    var loading = null;
    var failed = false;
    var token = null;
    var timer = null;
    var seq = 0;
    var items = [];
    var active = -1;
    var typesAccepted = true;

    function load() {
      if (lib) return Promise.resolve(lib);
      if (failed) return Promise.reject(new Error('maps unavailable'));
      if (loading) return loading;
      loading = new Promise(function (resolve, reject) {
        if (window.google && window.google.maps && typeof window.google.maps.importLibrary === 'function') {
          resolve();
          return;
        }
        var cbName = 'fjcRingSizerMapsReady';
        window[cbName] = function () { resolve(); };
        var script = document.createElement('script');
        script.src = 'https://maps.googleapis.com/maps/api/js?key=' + encodeURIComponent(key) +
          '&v=weekly&loading=async&libraries=places&language=en-GB&callback=' + cbName;
        script.async = true;
        script.onerror = function () { reject(new Error('maps script')); };
        document.head.appendChild(script);
      }).then(function () {
        return window.google.maps.importLibrary('places');
      }).then(function (placesLib) {
        lib = placesLib;
        // Google's list replaces the browser's own address suggestions on this field
        input.setAttribute('autocomplete', 'off');
        return lib;
      });
      loading.catch(function () { failed = true; loading = null; });
      return loading;
    }

    // Google reports a rejected key here; stop asking after that.
    var previousAuthFailure = window.gm_authFailure;
    window.gm_authFailure = function () {
      failed = true;
      lib = null;
      hide();
      if (typeof previousAuthFailure === 'function') previousAuthFailure();
    };

    function request(text) {
      var req = {
        input: text,
        sessionToken: token,
        includedRegionCodes: REGION_CODES,
        language: 'en-GB',
        region: 'gb'
      };
      if (typesAccepted) req.includedPrimaryTypes = ADDRESS_TYPES;
      return lib.AutocompleteSuggestion.fetchAutocompleteSuggestions(req).catch(function (err) {
        // an unrecognised type rejects the whole request: fall back to every type once
        if (typesAccepted) {
          typesAccepted = false;
          return request(text);
        }
        throw err;
      });
    }

    function search(text) {
      var my = ++seq;
      load().then(function () {
        if (!token) token = new lib.AutocompleteSessionToken();
        return request(text);
      }).then(function (result) {
        if (my !== seq || document.activeElement !== input) return;
        render((result && result.suggestions) || []);
      }).catch(function () {
        if (my === seq) hide();
      });
    }

    function hide() {
      list.hidden = true;
      list.innerHTML = '';
      items = [];
      active = -1;
      input.setAttribute('aria-expanded', 'false');
      input.removeAttribute('aria-activedescendant');
    }

    function render(suggestions) {
      items = [];
      list.innerHTML = '';
      active = -1;
      for (var i = 0; i < suggestions.length; i++) {
        var prediction = suggestions[i].placePrediction;
        if (!prediction) continue;
        var li = document.createElement('li');
        li.className = 'fjc-sizer-suggest__item';
        li.id = 'FjcSizerAddressOption' + items.length;
        li.setAttribute('role', 'option');
        li.setAttribute('aria-selected', 'false');
        li.setAttribute('data-index', String(items.length));
        var main = prediction.mainText ? prediction.mainText.toString() : prediction.text.toString();
        var secondary = prediction.secondaryText ? prediction.secondaryText.toString() : '';
        li.appendChild(document.createTextNode(main));
        if (secondary) {
          var span = document.createElement('span');
          span.className = 'fjc-sizer-suggest__secondary';
          span.textContent = secondary;
          li.appendChild(span);
        }
        list.appendChild(li);
        items.push(suggestions[i]);
      }
      if (!items.length) { hide(); return; }
      // Places data shown without a map must carry Google's attribution
      var credit = document.createElement('li');
      credit.className = 'fjc-sizer-suggest__attribution';
      credit.setAttribute('role', 'presentation');
      credit.textContent = 'Powered by Google';
      list.appendChild(credit);
      list.hidden = false;
      input.setAttribute('aria-expanded', 'true');
    }

    function setActive(index) {
      var options = list.querySelectorAll('.fjc-sizer-suggest__item');
      if (!options.length) return;
      if (index < 0) index = options.length - 1;
      if (index >= options.length) index = 0;
      for (var i = 0; i < options.length; i++) {
        options[i].classList.toggle('is-active', i === index);
        options[i].setAttribute('aria-selected', i === index ? 'true' : 'false');
      }
      active = index;
      input.setAttribute('aria-activedescendant', options[index].id);
      if (typeof options[index].scrollIntoView === 'function') {
        options[index].scrollIntoView({ block: 'nearest' });
      }
    }

    function component(components, type, short) {
      for (var i = 0; i < components.length; i++) {
        var c = components[i];
        if (c && c.types && c.types.indexOf(type) !== -1) {
          return (short ? (c.shortText || c.longText) : (c.longText || c.shortText)) || '';
        }
      }
      return '';
    }

    function setValue(selector, value, keepExisting) {
      var el = drawer.querySelector(selector);
      if (!el) return;
      if (keepExisting && !value) return;
      el.value = value || '';
      try { el.dispatchEvent(new Event('change', { bubbles: true })); } catch (e) { /* ignore */ }
    }

    function fill(components, typedText) {
      var countryCode = component(components, 'country', true).toUpperCase();
      var number = component(components, 'street_number');
      var route = component(components, 'route');
      var premise = component(components, 'premise');
      var subpremise = component(components, 'subpremise');
      var line1 = [number, route].filter(Boolean).join(' ');
      if (!line1) line1 = [premise, route].filter(Boolean).join(', ');
      else if (premise && premise !== number) line1 = premise + ', ' + line1;
      var town = component(components, 'postal_town') ||
        component(components, 'locality') ||
        component(components, 'sublocality') ||
        component(components, 'sublocality_level_1');
      // UK: the county (level 2; level 1 is only England/Scotland/Wales/NI). Ireland: level 1 is the county.
      var region = countryCode === 'IE'
        ? component(components, 'administrative_area_level_1')
        : component(components, 'administrative_area_level_2');
      var postcode = component(components, 'postal_code');

      setValue('[data-fjc-sizer-address]', line1 || typedText);
      setValue('[data-fjc-sizer-address2]', subpremise, true);
      setValue('[data-fjc-sizer-city]', town);
      setValue('[data-fjc-sizer-region]', region);
      setValue('[data-fjc-sizer-postcode]', postcode);
      var country = drawer.querySelector('[data-fjc-sizer-country]');
      if (country && countryCode) {
        for (var i = 0; i < country.options.length; i++) {
          if ((country.options[i].getAttribute('data-region') || '') === countryCode) {
            country.selectedIndex = i;
            break;
          }
        }
      }
      // move on to what is still missing
      var next = ['[data-fjc-sizer-postcode]', '[data-fjc-sizer-city]', '#FjcSizerEmail'];
      for (var n = 0; n < next.length; n++) {
        var el = drawer.querySelector(next[n]);
        if (el && !el.value) { el.focus(); return; }
      }
      var email = drawer.querySelector('#FjcSizerEmail');
      if (email) email.focus();
    }

    function choose(index) {
      var suggestion = items[index];
      if (!suggestion || !suggestion.placePrediction) return;
      var prediction = suggestion.placePrediction;
      var typedText = prediction.text.toString();
      input.value = typedText;
      hide();
      token = null; // the session ends with fetchFields; the next keystroke starts a new one
      var place = prediction.toPlace();
      place.fetchFields({ fields: ['addressComponents'] }).then(function () {
        fill(place.addressComponents || [], typedText);
      }).catch(function () {
        // keep the chosen text as the address line; the customer fills the rest
      });
    }

    input.addEventListener('input', function () {
      var text = input.value.trim();
      clearTimeout(timer);
      if (text.length < 3) { seq++; hide(); return; }
      timer = setTimeout(function () { search(text); }, 250);
    });

    input.addEventListener('keydown', function (e) {
      var open = !list.hidden;
      if (e.key === 'ArrowDown' && open) { e.preventDefault(); setActive(active + 1); return; }
      if (e.key === 'ArrowUp' && open) { e.preventDefault(); setActive(active - 1); return; }
      if (e.key === 'Enter' && open) {
        e.preventDefault(); // never submit the form from the suggestion list
        if (active >= 0) choose(active); else hide();
        return;
      }
      if (e.key === 'Escape' && open) {
        e.preventDefault();
        e.stopPropagation(); // close the list, not the drawer
        hide();
      }
    });

    input.addEventListener('blur', function () {
      // after a click on an option (mousedown below keeps the focus) and tabbing away
      setTimeout(function () { if (document.activeElement !== input) hide(); }, 150);
    });

    list.addEventListener('mousedown', function (e) {
      e.preventDefault(); // keep the focus in the input so blur does not hide the list first
    });
    list.addEventListener('click', function (e) {
      var option = e.target && e.target.closest ? e.target.closest('.fjc-sizer-suggest__item') : null;
      if (!option) return;
      choose(parseInt(option.getAttribute('data-index'), 10));
    });

    return {
      boot: function () { load().catch(function () { /* typed form only */ }); },
      hide: hide,
      isListOpen: function () { return !list.hidden; }
    };
  })();

  /* ---------------- Wiring ---------------- */

  var LINK_HASH = '#request-ring-sizer';

  function linkDetails(link) {
    var inFooter = !!(link && link.closest('footer, [id*="footer"]'));
    return {
      productTitle: inFooter ? 'Footer link' : 'Site link',
      url: window.location.href.split('#')[0]
    };
  }

  document.addEventListener('click', function (e) {
    var target = e.target;
    if (!target || !target.closest) return;
    if (target.closest('[data-fjc-sizer-close]')) {
      e.preventDefault();
      closeDrawer();
      return;
    }
    var link = target.closest('a[href]');
    if (link && link.hash === LINK_HASH && !isOpen()) {
      e.preventDefault();
      openDrawer(linkDetails(link), link);
    }
  });

  if (window.location.hash === LINK_HASH) {
    openDrawer(linkDetails(null), null);
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', window.location.href.split('#')[0]);
    }
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && isOpen()) closeDrawer();
  });

  document.addEventListener('submit', handleSubmit);
  // before any focus can reach the form (the drawer is closed until a click), so the captcha
  // provider captures this script's submit() rather than the native one
  hookCaptchaSubmit();
})();
